<template>

  <div>
    <div class="card card-info">
      <!--<div class="card-header">
        <a href="../Administration/CreateEmployeeUser" class="btn btn-sm btn-outline-secondary btn-default"><i class="fa fa-plus text-black-50"> <b>Add New</b></i></a>
      </div>-->
      <div class="card-body">
        <div class="row">
          <div class="col-md-12">
            <div class="table-responsive-sm">
              <table id="tblEmployeeUser" style="width: 100%" class="table table-bordered table-sm">
                <thead class="bg-info">
                  <tr>
                    <th>Emp. Code</th>
                    <th>Full Name</th>
                    <th>Father Name</th>
                    <th>CNIC</th>
                    <th>Campus</th>
                    <th>UserName</th>
                    <th style="width: 10px;"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in employees">
                    <td>{{item.EmpCode}}</td>
                    <td>{{item.Name}}</td>
                    <td>{{item.FatherName}}</td>
                    <td>{{item.CNIC}}</td>
                    <td>{{item.Campus}}</td>
                    <td>{{item.UserName}}</td>
                    <td align="center" style="white-space:nowrap">
                      <!--<a :href="'../Administration/CreateEmployeeUser?id=' + item.ID" target='_blank' class='btn btn-primary' id='" + row.id + "'>Edit</a>-->
                      <button type='button' class='btn btn-info btnSet' v-on:click="showModal(item.ID)">Reset Password</button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div id="myModal" class="modal fade" role="dialog">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header bg-info">
            <h4 class="modal-title">Confirm Reset Password</h4>
          </div>
          <div class="modal-body text-center">
            <h2>Are you sure you want to reset password?</h2>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-success" v-on:click="resetPassword()" data-dismiss="modal">Reset Password</button>
            <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>
<script>

  const axios = require('axios').default;

  //$(document).ready(function () {

  //  var userID = "";

  //  $(".btnSet").click(function () {
  //    userID = $(this).attr('name')
  //    alert($(this).attr('name'));
  //    $('myModal').modal('show');
  //  });

  //  if (!$.fn.dataTable.isDataTable('#tblEmployeeUser')) {
  //    var table = $('#tblEmployeeUser').DataTable({
  //      "processing": true,
  //      "serverSide": true,
  //      "filter": true,
  //      "ajax": {
  //        "url": "/api/RoleApi/getEmployeeUserList",
  //        "type": "POST",
  //        "datatype": "json"
  //      },
  //      "columnDefs": [{
  //        "targets": [0],
  //        "visible": false,
  //        "searchable": false
  //      }],
  //      "columns": [
  //        { "data": "EmpCode", "autoWidth": true },
  //        { "data": "Name", "autoWidth": true },
  //        { "data": "FatherName", "autoWidth": true },
  //        { "data": "CNIC", "autoWidth": true },
  //        { "data": "Campus", "autoWidth": true },
  //        { "data": "UserName", "autoWidth": true },
  //        {
  //          "render": function (data, type, row, meta) {
  //            return actions(data, type, row, meta);
  //          }
  //        },
  //      ]
  //    });
  //  }

  //  function actions(data, type, row, meta) {
  //    return "<a href='../Administration/CreateEmployeeUser?id=" + row.ID + "' target='_blank' class='btn btn-primary' id='" + row.id + "'>Edit</a>" +
  //      "<button type='button' class='btn btn-primary btnSet'  name='" + row.ID + "'>Reset Password</button>"
  //  }

  //  $('button').on('click', function (e) {
  //    alert("abc");
  //  });

  //  function confirm() {
  //    axios.post('/api/RoleApi/resetPassword?id=' + userID)
  //      .then(function (res) {
  //        toastr.success("Reset Successfully");
  //        $('myModal').modal('hide');
  //      });
  //  }
  //});

  export default ({

    data() {
      return {
        employees: [],
        id: 0
      }
    },

    created: function () {
      this.pageLoad();
    },

    updated: function () {

    },

    methods: {

      pageLoad() {
        startReq();
        var vm = this;
        axios.post('/api/RoleApi/getEmployeeUserList')
          .then(function (res) {
            vm.employees = res.data;
            endReq();
          })
      },

      showModal(id) {
        this.id = id;
        $('#myModal').modal('show');
      },

      resetPassword() {
        axios.post('/api/RoleApi/resetPassword?id=' + this.id)
          .then(function (res) {
            toastr.success("Reset Successfully");
            $('#myModal').modal('hide');
          });
      }

    },

  });

</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/core/listEmployeeUser.vue